import ObjectivesOverviewPage from './ObjectivesOverviewPage';

export default ObjectivesOverviewPage;
